import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../../../../graphql/types.generated';
export type ArchiveBookingDocumentMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.ArchiveInput;
}>;

export type ArchiveBookingDocumentMutationResult = { __typename?: 'Mutation' } & {
  bookingDocumentArchive?: GraphQLTypes.Maybe<
    { __typename?: 'ArchivePayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const ArchiveBookingDocumentDocument = gql`
  mutation archiveBookingDocument($input: ArchiveInput!) {
    bookingDocumentArchive(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
